import { getInterfaceUserAgentType, handleDownload } from "./appInterface";

function downloadPDF(url: string, filename?: string) {
  // User-Agent Type이 앱에서 요청하는 것인지, 웹에서 요청하는 것인지에 따라 사용 구분
  // 웹인 경우
  if (getInterfaceUserAgentType() === "Web") {
    // PDF 파일 가져오기
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("파일을 다운로드할 수 없습니다.");
        }
        return response.blob(); // Blob 데이터로 변환
      })
      .then((blob) => {
        // Blob 데이터를 다운로드 링크로 생성
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.href = url; // Blob 데이터 URL
        link.download = filename || "download.pdf"; // 파일 이름 설정
        document.body.appendChild(link);
        link.click(); // 다운로드 실행
        document.body.removeChild(link); // 링크 제거
        URL.revokeObjectURL(url); // 메모리 해제
      })
      .catch((error) => {
        console.error("다운로드 중 에러가 발생했습니다:", error);
      });
  } else {
    // 앱인 경우 각 앱에 맞게 handler 호출
    handleDownload(url);
  }
}

export default downloadPDF;
